import { z } from 'zod';
export const createAddressSchema = z.object({
    label: z.string().min(1, 'Label is required'),
    name: z.string().min(1, 'Name is required'),
    name2: z.string().nullable().optional(),
    address1: z.string().min(1, 'Address is required'),
    address2: z.string().nullable().optional(),
    city: z.string().min(1, 'City is required'),
    state: z.string().min(1, 'State is required'),
    zip: z.string().min(1, 'ZIP is required'),
    country: z.string().min(1).default('US'),
});
export const updateAddressSchema = createAddressSchema.partial().extend({
    is_active: z.boolean().optional(),
});
//# sourceMappingURL=address.js.map